// extracted by mini-css-extract-plugin
var _1 = "salesReportTable-module__action-button-container";
var _2 = "salesReportTable-module__cancel-transaction-button";
var _3 = "salesReportTable-module__gold-row";
var _4 = "salesReportTable-module__slot-left";
var _5 = "salesReportTable-module__slot-middle";
var _6 = "salesReportTable-module__slot-right";
var _7 = "salesReportTable-module__transaction-action-label";
export { _1 as "action-button-container", _2 as "cancel-transaction-button", _3 as "gold-row", _4 as "slot-left", _5 as "slot-middle", _6 as "slot-right", _7 as "transaction-action-label" }
